import React from 'react';
import styled from 'styled-components';
import { fontFamily, fontSize } from '../../../../../../../../constants/text';
import { colors } from '../../../../../../../../constants/colors';
import Carrier from '../../../../../Insurance/components/InsuranceCard/components/Carrier';
import ProgressBar from '../../../../../../../SolvPatternLibrary/ProgressBars/ProgressBar';

const Root = styled.div.withConfig({ componentId: 'sc-1emfroe-0' })`
  max-width: 100%;
  border-radius: 8px;
  cursor: pointer;
  padding: 14px 16px;
  background-color: ${colors.theWhiteAlbum};
`;
const StyledCarrier = styled(Carrier).withConfig({ componentId: 'sc-1emfroe-1' })`
  margin-bottom: 11px;
  padding: 0;
`;
const H1 = styled.h1.withConfig({ componentId: 'sc-1emfroe-2' })`
  color: ${colors.squid};
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.bold};
  text-overflow: ellipsis;
`;
const H2 = styled.h2.withConfig({ componentId: 'sc-1emfroe-3' })`
  color: ${colors.lightText};
  font-size: ${fontSize.mediumSmall};
  font-family: ${fontFamily.book};
  text-overflow: ellipsis;
`;
const StyledProgressBar = styled(ProgressBar).withConfig({ componentId: 'sc-1emfroe-4' })`
  margin-top: 9px;
`;
const Action = styled.div.withConfig({ componentId: 'sc-1emfroe-5' })`
  color: ${colors.crunchBerry};
  font-size: ${fontSize.default};
  margin: 9px 0 4px;
`;

type Props = {
  applied: number;
  category: string;
  insuranceCarrierName?: string;
  limit: number;
  logo: string;
};

const View = (props: Props) => {
  const { applied, category, insuranceCarrierName, limit, logo } = props;
  const appliedCopy =
    applied < limit ? `$${applied} spent on care` : `$${limit} ${category} reached`;
  const limitCopy =
    applied < limit
      ? `Towards your $${limit} ${category}`
      : 'Insurance is now covering part of your costs';

  return (
    <Root>
      {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'insurerCarrierName' does not exist on ty... Remove this comment to see the full error message */}
      <StyledCarrier insurerCarrierName={insuranceCarrierName} logo={logo} />

      <H1 data-testid="applied">{appliedCopy}</H1>

      <H2 data-testid="limit">{limitCopy}</H2>

      <StyledProgressBar
        currentValue={applied}
        shouldAnimateOnRender={false}
        shouldAnimateOnSawComponent
        upperBound={limit}
        width="100%"
      />

      <Action>Explore my benefits</Action>
    </Root>
  );
};

export default View;
